import { __spreadArray } from "tslib";
import { useEffect } from 'react';
export function useClickTracking(ref, onLinkClick) {
    useEffect(function () {
        var links = [];
        if (ref.current && onLinkClick) {
            var linksArr = Array.from(ref.current.querySelectorAll('a'));
            links = __spreadArray([ref.current], linksArr, true).filter(function (el) { return el.matches('a'); })
                .map(function (e) { return e; });
            links.forEach(function (link) {
                link.addEventListener('click', onLinkClick, true);
                link.addEventListener('auxclick', onLinkClick, true);
            });
        }
        return function () {
            if (ref.current && onLinkClick) {
                links.forEach(function (link) {
                    link.removeEventListener('click', onLinkClick, true);
                    link.removeEventListener('auxclick', onLinkClick, true);
                });
            }
        };
    }, [ref.current]);
}
